import { createContext, useContext } from "react";
import type { MapPin } from "@roll1/shared";

/**
 * P09b (Q-7 / Q-8): what a GM Studio map pane and the beat beside it say to each other — «Place on map» waiting for
 * a click, a note card dropped on a map, a pin clicked, a pin lit from its note. Provided by the Studio surface; the
 * table has none (its pins and drops go their own way: a popup at the pin, a pin of the GM only).
 */
export interface StudioMapLink {
  /** «Поставить на карту»: the next click on this map is the place (the note and the map it waits for). */
  readonly placing: { readonly entryId: string; readonly pageId: string } | undefined;
  readonly onPlaceAt: (pageId: string, x: number, y: number) => void;
  /** A note card dropped on a map of Studio. */
  readonly onDropNote: (entryId: string, pageId: string, x: number, y: number) => void;
  /** A click on a pin of a Studio map. */
  readonly onPinClick: (pin: MapPin, pageId: string) => void;
  /** The pin that is lit on the maps (its note is hovered or its badge was pressed). */
  readonly highlightPinId: string | undefined;
}

export const StudioMapLinkContext = createContext<StudioMapLink | null>(null);

export function useStudioMapLink(): StudioMapLink | null {
  return useContext(StudioMapLinkContext);
}
